import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import {
  Icon,
  CheckboxFieldReduxFormWrapper,
  StandardFieldLabel,
} from '@adc/ui-adc'

const getFiltersLanguage = ({
  inspectionAllowedFilterEnabled,
  privateSellerEnabled,
}) => {
  const targetLanguage = {}

  if (privateSellerEnabled) {
    targetLanguage.occupancyStatusLabel = 'Vacant'
    targetLanguage.occupancyStatusSubLabel =
      'The property is vacant or will be vacant at a mutually agreed date after closing.'
    targetLanguage.accessAvailableLabel = 'Private Tour Available'
    targetLanguage.accessAvailableSubLabel =
      'View the property through scheduled visits or an open house.'
    targetLanguage.financingAvailableLabel = 'Eligible for Financing'
    targetLanguage.financingAvailableSubLabel =
      'Properties that could be financed with a conventional mortgage.'
    targetLanguage.inspectionAllowedLabel = 'Inspection Contingency Offered'
    targetLanguage.inspectionAllowedSubLabel =
      'The seller has agreed to allow an inspection contingency as a part of the sale.'
  } else {
    if (inspectionAllowedFilterEnabled) {
      targetLanguage.occupancyStatusLabel =
        'Vacant or Will Be Vacant at Closing'
      targetLanguage.occupancyStatusSubLabel =
        'The property is either already vacant or will be vacant by closing; no eviction needed.'
      targetLanguage.accessAvailableLabel = 'Property Tour Available'
      targetLanguage.accessAvailableSubLabel =
        'View the property before bidding through scheduled visits or open house events.'
    } else {
      targetLanguage.occupancyStatusLabel = 'Vacant'
      targetLanguage.occupancyStatusSubLabel =
        'Not all foreclosed properties are empty. But for these, no eviction is needed.'
      targetLanguage.accessAvailableLabel = 'Interior Access Available'
      targetLanguage.accessAvailableSubLabel =
        'Schedule a visit to view the property'
    }
    targetLanguage.financingAvailableLabel = 'Eligible for Financing'
    targetLanguage.financingAvailableSubLabel =
      'These could be financed with a residential mortgage.'
    targetLanguage.inspectionAllowedLabel = 'Inspection Contingency Allowed'
    targetLanguage.inspectionAllowedSubLabel =
      "Seller will consider offers that are contingent on buyer's inspection."
  }

  return targetLanguage
}

const ConditionFiltersContent = ({
  elmId,
  className,
  submitForms,
  inspectionAllowedFilterEnabled,
  privateSellerEnabled,
}) => {
  const filtersLanguage = getFiltersLanguage({
    inspectionAllowedFilterEnabled,
    privateSellerEnabled,
  })
  return (
    <section data-elm-id={elmId} className={className}>
      <Field
        compact
        name='occupancy_status'
        elmId={`${elmId}_occupancy_status`}
        onChange={submitForms}
        type='checkbox'
        label={
          <StandardFieldLabel
            label={
              <>
                <Icon iconStyle='light' name='sign' />
                {filtersLanguage.occupancyStatusLabel}
              </>
            }
            subLabel={filtersLanguage.occupancyStatusSubLabel}
          />
        }
        component={CheckboxFieldReduxFormWrapper}
      />
      <Field
        compact
        name='access_available'
        elmId={`${elmId}_access_available`}
        onChange={submitForms}
        type='checkbox'
        label={
          <StandardFieldLabel
            label={
              <>
                <Icon iconStyle='light' name='door-open' />
                {filtersLanguage.accessAvailableLabel}
              </>
            }
            subLabel={filtersLanguage.accessAvailableSubLabel}
          />
        }
        component={CheckboxFieldReduxFormWrapper}
      />
      <Field
        compact
        name='financing_available'
        elmId={`${elmId}_financing_available`}
        onChange={submitForms}
        type='checkbox'
        label={
          <StandardFieldLabel
            label={
              <>
                <Icon iconStyle='light' name='hand-holding-usd' />
                {filtersLanguage.financingAvailableLabel}
              </>
            }
            subLabel={filtersLanguage.financingAvailableSubLabel}
          />
        }
        component={CheckboxFieldReduxFormWrapper}
      />
      {inspectionAllowedFilterEnabled && (
        <Field
          compact
          name='inspectionAllowed'
          elmId={`${elmId}_inspection_allowed`}
          onChange={submitForms}
          type='checkbox'
          label={
            <StandardFieldLabel
              label={
                <>
                  <Icon iconStyle='light' name='magnifying-glass-location' />
                  {filtersLanguage.inspectionAllowedLabel}
                </>
              }
              subLabel={filtersLanguage.inspectionAllowedSubLabel}
            />
          }
          component={CheckboxFieldReduxFormWrapper}
        />
      )}
    </section>
  )
}

ConditionFiltersContent.propTypes = {
  className: PropTypes.string,
  elmId: PropTypes.string.isRequired,
  submitForms: PropTypes.func.isRequired,
  inspectionAllowedFilterEnabled: PropTypes.bool.isRequired,
  privateSellerEnabled: PropTypes.bool.isRequired,
}

export default ConditionFiltersContent
